const mediaItems = [
  {
    title: '韩漫推荐：2024年度必看TOP10',
    desc: '精选年度最受读者喜爱的韩漫作品，从恋爱到奇幻一网打尽',
    icon: 'ri-play-circle-line',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20collage%20with%20various%20characters%20from%20different%20genres%2C%20colorful%20and%20dynamic%20composition%2C%20warm%20coral%20and%20cream%20background%2C%20editorial%20style%2C%20high%20detail%2C%20harmonious%20layout&width=500&height=340&seq=media-01&orientation=landscape',
  },
  {
    title: '追更指南：如何高效追踪韩漫更新',
    desc: '教你设置韩漫更新提醒，不再错过任何最新章节',
    icon: 'ri-guide-line',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20desk%20setup%20with%20tablet%20displaying%20Korean%20webtoon%20art%2C%20warm%20lighting%2C%20coffee%20cup%2C%20notebook%2C%20modern%20minimal%20workspace%2C%20soft%20coral%20and%20neutral%20tones%2C%20productive%20atmosphere%2C%20high%20detail&width=500&height=340&seq=media-02&orientation=landscape',
  },
  {
    title: '韩漫作者访谈：走进创作者的幕后故事',
    desc: '独家对话热门韩漫作者，揭秘连载背后的创作历程',
    icon: 'ri-mic-line',
    img: 'https://readdy.ai/api/search-image?query=Art%20studio%20scene%20with%20Korean%20manhwa%20drawing%20tablet%20and%20sketches%2C%20creative%20workspace%2C%20warm%20natural%20light%2C%20art%20supplies%2C%20digital%20illustration%20in%20progress%2C%20soft%20amber%20tones%2C%20artistic%20atmosphere%2C%20high%20detail&width=500&height=340&seq=media-03&orientation=landscape',
  },
];

export function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-secondary-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">追更指南</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">韩漫追更技巧与精彩内容推荐</p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer group">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90">
                    <i className={`${item.icon} text-primary-500 text-xl`}></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const faqItems = [
  {
    q: '韩漫屋是什么类型的平台？',
    a: '韩漫屋是一个专注于韩漫追更的信息聚合平台，实时追踪韩漫最新更新、韩漫连载更新动态，为读者提供最新章节的更新提醒服务，完全免费使用，无需注册登录。',
  },
  {
    q: '如何接收韩漫更新提醒？',
    a: '您可以直接访问韩漫屋首页的"最新更新"模块查看实时更新列表，也可以通过关注我们的微信公众号获取推送通知。我们每5分钟自动刷新一次更新数据，确保第一时间展示韩漫最新章节信息。',
  },
  {
    q: '韩漫屋收录了多少部韩漫作品？',
    a: '目前韩漫屋已追踪超过2,000部热门韩漫作品，涵盖恋爱甜宠、奇幻冒险、异世穿越、复仇逆袭、校园青春、悬疑推理、BL纯爱、动作热血、都市职场等多种题材，并持续扩充收录范围。',
  },
  {
    q: '韩漫屋是否需要付费使用？',
    a: '完全不需要。韩漫屋秉承免费追更的理念，所有韩漫更新信息均可免费查看。我们不向读者收取任何费用，也无需注册会员或登录账号即可浏览全部更新内容。',
  },
  {
    q: '如何向韩漫屋推荐新的韩漫作品？',
    a: '我们非常欢迎读者推荐优秀的韩漫作品。您可以通过页面顶部的"联系我们"区域，发送邮件至 contact@hanmanwu.com，或加入官方QQ群 8088088 提交推荐，我们的编辑团队会尽快审核并收录。',
  },
];

export function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">常见问答</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">关于韩漫追更平台的常见问题解答</p>
        <div className="mt-6 space-y-3">
          {faqItems.map((item, idx) => (
            <details key={idx} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-900 pr-8">{item.q}</h3>
                <i className="ri-add-line text-foreground-500 group-open:rotate-45 transition-transform text-lg flex-shrink-0"></i>
              </summary>
              <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

const cardItems = [
  {
    title: '恋爱甜宠精选',
    desc: '甜蜜浪漫的韩漫恋爱故事，治愈你的每一天',
    tag: '热门题材',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20coral%20tones%2C%20dreamy%20atmosphere%2C%20spring%20setting%2C%20gentle%20color%20palette%2C%20high%20detail%2C%20beautiful%20composition&width=400&height=280&seq=cards-01&orientation=landscape',
  },
  {
    title: '奇幻冒险世界',
    desc: '穿越异世界，探索神秘奇幻的韩漫宇宙',
    tag: '人气飙升',
    img: 'https://readdy.ai/api/search-image?query=Enchanted%20fantasy%20forest%20with%20glowing%20magical%20elements%2C%20Korean%20webtoon%20style%2C%20ethereal%20atmosphere%2C%20soft%20mint%20and%20warm%20highlights%2C%20mystical%20creatures%2C%20high%20detail%2C%20dreamy%20scene&width=400&height=280&seq=cards-02&orientation=landscape',
  },
  {
    title: '复仇逆袭爽文',
    desc: '主角反转人生，逆袭打脸的韩漫爽文合集',
    tag: '读者最爱',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20Korean%20manhwa%20scene%20of%20a%20powerful%20female%20character%20in%20royal%20attire%2C%20intense%20expression%2C%20warm%20gold%20and%20crimson%20tones%2C%20palace%20background%2C%20dynamic%20composition%2C%20high%20contrast&width=400&height=280&seq=cards-03&orientation=landscape',
  },
  {
    title: '校园青春物语',
    desc: '那些年我们一起追的韩漫校园恋爱故事',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20classroom%20illustration%20with%20warm%20sunlight%2C%20manhwa%20art%20style%2C%20young%20students%2C%20soft%20coral%20and%20cream%20tones%2C%20nostalgic%20atmosphere%2C%20slice%20of%20life%20aesthetic&width=400&height=280&seq=cards-04&orientation=landscape',
  },
  {
    title: 'BL纯爱殿堂',
    desc: '高人气BL韩漫佳作，纯爱故事触动心弦',
    tag: '口碑推荐',
    img: 'https://readdy.ai/api/search-image?query=Two%20male%20characters%20in%20Korean%20manhwa%20style%20facing%20each%20other%20in%20a%20library%2C%20warm%20lighting%2C%20soft%20amber%20and%20neutral%20tones%2C%20emotional%20atmosphere%2C%20beautiful%20composition%2C%20high%20detail&width=400&height=280&seq=cards-05&orientation=landscape',
  },
  {
    title: '悬疑推理剧场',
    desc: '烧脑悬疑韩漫，每一话都让人欲罢不能',
    tag: '新作上线',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20alleyway%20at%20night%20in%20Korean%20manhwa%20art%20style%2C%20dramatic%20shadows%2C%20warm%20street%20lamp%20glow%2C%20noir%20atmosphere%2C%20intriguing%20composition%2C%20soft%20coral%20and%20dark%20tones%2C%20high%20detail&width=400&height=280&seq=cards-06&orientation=landscape',
  },
];

export function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">热门推荐</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">根据读者追更热度精选的韩漫推荐专题</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <div key={item.title} className="rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer group">
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const featureItems = [
  {
    title: '实时追更提醒',
    desc: '每5分钟自动刷新韩漫最新更新数据，第一时间推送最新章节提醒，确保你永远走在追更最前线。',
    icon: 'ri-notification-3-line',
  },
  {
    title: '完全免费追更',
    desc: '韩漫屋坚持免费服务理念，所有韩漫更新信息免费查看，无需注册、无需登录、无需付费即可完整浏览。',
    icon: 'ri-money-dollar-circle-line',
  },
  {
    title: '海量韩漫覆盖',
    desc: '已追踪超过2,000部韩漫作品，涵盖恋爱、奇幻、穿越、复仇、校园等十余种题材，持续扩充收录。',
    icon: 'ri-stack-line',
  },
  {
    title: '多端同步追更',
    desc: '支持电脑、平板、手机等多种设备访问，微信公众号同步推送更新提醒，随时随地掌握韩漫动态。',
    icon: 'ri-device-line',
  },
  {
    title: '社区互动交流',
    desc: '活跃的读者社群，QQ群和微信公众号汇聚韩漫同好，交流追更心得，分享推荐好作品。',
    icon: 'ri-group-line',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-primary-50/50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">追更优势</h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">为什么超过百万读者选择韩漫屋追更韩漫</p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featureItems.map((item, idx) => (
            <div key={idx} className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}